import { createFileRoute } from '@tanstack/react-router';
import { requireFeature } from '@portal/platform/guards';
import { OrdersTyresPage } from '@/features/orders-tyres/orders-tyres-page';

/** The tyre orders ("Bestillinger"). The list requires `tyre-order:read`. */
export const Route = createFileRoute('/_app/orders/tyres')({
  staticData: { featureKey: 'orders-tyres' },
  beforeLoad: ({ context, location }) =>
    requireFeature(context, location, {
      feature: 'orders-tyres',
      permissions: ['tyre-order:read'],
    }),
  component: OrdersTyresPage,
});
